import { AbstractControl, ValidatorFn } from '@angular/forms';

export class ValidatorsHelper {
    /**
 * Updates a form control's errors while preserving existing errors.
 * If the condition is true, the specified error is added; otherwise, it is removed.
 * 
 * @param control The form control to update.
 * @param errorKey The key of the error to add or remove.
 * @param condition If true, the error is added; if false, it is removed.
 * @param errorValue Optional value for the error; defaults to `true` if not provided.
 */
    static updateValidationErrors(control: AbstractControl, errorKey: string, condition: boolean, errorValue: any = true) {
        const existingErrors = control.errors || {};

        if (condition) {
            // Add or update the specified error
            control.setErrors({
                ...existingErrors,
                [errorKey]: errorValue
            });
        } else {
            // Remove the specified error key if it exists
            delete existingErrors[errorKey];

            // Set errors to null if no other errors remain
            control.setErrors(Object.keys(existingErrors).length ? existingErrors : null);
        }
    }

}